import { render, staticRenderFns } from "./EditReasonModal.vue?vue&type=template&id=6c0989d2&scoped=true&"
import script from "./EditReasonModal.vue?vue&type=script&lang=js&"
export * from "./EditReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0989d2",
  null
  
)

export default component.exports